import { Quote } from 'lucide-react';

const testimonials = [
  {
    quote: "Emplozera Studio transformed our clinic's online presence. Within 3 months, we saw a significant jump in patient appointments through Google searches. Their understanding of healthcare marketing is exceptional.",
    name: 'Dr. Sarah Mitchell',
    role: 'Dermatologist, London',
    initials: 'SM',
  },
  {
    quote: "The accounting + marketing combo is exactly what we needed. No more dealing with multiple vendors. Our tax compliance is seamless and our social media is thriving. Highly recommended for any doctor!",
    name: 'Dr. James Rodriguez',
    role: 'Cardiologist, Miami',
    initials: 'JR',
  },
  {
    quote: "Our patient bookings tripled within 6 months. The reputation management and Google Business optimization strategies built our 5-star profile. The ROI has been incredible for our fertility clinic.",
    name: 'Dr. Amira Hassan',
    role: 'IVF Specialist, Dubai',
    initials: 'AH',
  },
  {
    quote: "As an orthopaedic surgeon, I was sceptical about digital marketing. Emplozera Studio proved me wrong. Their SEO-optimized website and social media content brought us patients we never expected to reach.",
    name: 'Dr. Marcus Weber',
    role: 'Orthopaedic Surgeon, Berlin',
    initials: 'MW',
  },
];

const Testimonials = () => (
  <section id="testimonials" className="bg-[#F9F7F2] py-20 lg:py-28" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-14">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#8C6330] mb-4">What Doctors Say</p>
        <h2 className="font-heading text-3xl sm:text-4xl tracking-tight leading-tight text-[#11181C]">
          Trusted by Healthcare Professionals Worldwide
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {testimonials.map((t, i) => (
          <div
            key={t.name}
            className="bg-white border border-[#D6CEBF] rounded-2xl p-7 shadow-sm hover:shadow-lg transition-all duration-300 service-card"
            data-testid={`testimonial-${i}`}
          >
            <Quote size={24} className="text-[#8C6330]/40 mb-4" />
            <p className="text-sm leading-relaxed text-[#4A5568] mb-6 italic">"{t.quote}"</p>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#1B3F33] flex items-center justify-center">
                <span className="text-sm font-bold text-white">{t.initials}</span>
              </div>
              <div>
                <p className="text-sm font-medium text-[#11181C]">{t.name}</p>
                <p className="text-xs text-[#4A5568]">{t.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
